'use client';

import { isServer, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { OpenAPI } from '@/lib/jp-api/requests';
import { PortalProvider } from '@/components/ui/PortalProvider';
import { OverlaysProvider } from '@/components/ui/Overlays';
import { ToasterOutlet, ToasterProvider } from '@/components/ui/Toaster';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { CurrencyContextProvider } from '@/components/currency-provider/currency-provider';

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

function getQueryClient() {
  OpenAPI.CREDENTIALS = 'include';
  OpenAPI.WITH_CREDENTIALS = true;
  if (isServer) {
    OpenAPI.BASE = process.env.JACKPOT_API!;
    return makeQueryClient();
  } else {
    OpenAPI.BASE = process.env.NEXT_PUBLIC_JACKPOT_API!;
    if (!browserQueryClient) browserQueryClient = makeQueryClient();
    return browserQueryClient;
  }
}

export default function Providers({ children }: React.PropsWithChildren) {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <CurrencyContextProvider>
        <PortalProvider>
          <OverlaysProvider>
            <ToasterProvider>
              {children}
              <ToasterOutlet />
            </ToasterProvider>
          </OverlaysProvider>
        </PortalProvider>
      </CurrencyContextProvider>
    </QueryClientProvider>
  );
}
